export const getClamped = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), Math.max(max, min));
